import React from "react";
import {categoryModuleService, departmentService, moduleService} from "../jwt/_services";
import {categoryService} from "../jwt/_services/clasificator/categoryService";

export const departmentProvider = {
    getOptions,
    getItem,
};

async function getOptions(){
    try {
        const listItems = await departmentService.getPagedList(0, 100);

        return listItems.data.map((itemData) => {
            const { id, name } = itemData
            return (
                {
                    id: id,
                    value: name,
                    label: <div><label>{name}</label></div>}
            )
        });
    } catch (error) {
       console.log(error.message)
    }
}

async function getItem(id){
    try {
        const item = await departmentService.getItem(id);

        return (
            {
                id: item.id,
                value: item.name,
                label: <div><label>{item.name}</label></div>}
        );
    } catch (error) {
        console.log(error.message)
    }
}